import vue from 'vue'
import app from './app.vue'
import store from './store'
import request from './request'
import router from './router/index'
import fragment from 'vue-fragment'
  import VueQuillEditor from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  vue.use(VueQuillEditor);
vue.use(fragment.Plugin)
import "@/assets/theme/index.css";
import element from "element-ui";
const windowWidth = window.screen.width;
let elementSize = 'small';
	if (windowWidth < 500) 
	element.Message.info('请用横屏浏览,并刷新网页')
// import Vue2editor from "vue2-editor";
// vue.use(Vue2editor);
vue.use(element, {
	size: elementSize,
	zIndex: 3000
});
import i18n from './language' // Internationalization
import axios from 'axios'
vue.prototype.$axios = axios;
import title from '@/components/form/com-form-title'
import uploaders from '@/components/form/com-form-uploaders'
import editor from '@/components/form/com-form-editor'
import map from '@/components/form/com-form-map'
import val from '@/components/form/com-form-val'
import tree from '@/components/form/com-form-tree'
import video from '@/components/form/com-form-video'
import image from '@/components/form/com-form-image'
import region from '@/components/form/com-form-region'
import operate from '@/components/page/com-page-operate'
import imgurl from '@/components/page/com-page-imgurl'
import returns from '@/components/page/com-page-return'
import orders from '@/components/page/com-page-orders'
import titles from '@/components/page/com-page-title'
import isshow from '@/components/page/com-page-isshow'
import number from '@/components/page/com-page-number'
import imports from '@/components/page/com-page-import'
import columns from '@/components/page/com-page-columns'
import exportsa from '@/components/page/com-page-export'
import index from '@/components/page/com-page-index'
import button from '@/components/page/com-page-button'
import areas from '@/components/page/com-page-area'
vue.component('com-form-title', title)
vue.component('com-form-uploaders', uploaders)
vue.component('com-page-title', titles)
vue.component('com-page-imgurl', imgurl)
vue.component('com-form-editor', editor)
vue.component('com-form-map', map)
vue.component('com-form-val', val)
vue.component('com-form-tree', tree)
vue.component('com-form-video', video)
vue.component('com-form-image', image)
vue.component('com-form-region', region)
vue.component('com-page-operate', operate)
vue.component('com-page-return', returns)
vue.component('com-page-orders', orders)
vue.component('com-page-isshow', isshow)
vue.component('com-page-number', number)
vue.component('com-page-import', imports)
vue.component('com-page-columns', columns)
vue.component('com-page-button', button)
vue.component('com-page-index', index)
vue.component('com-page-export', exportsa)
vue.component('com-page-area', areas)
vue.config.productionTip = false
vue.prototype.$size = elementSize;
vue.prototype.$tableHeight = window.screen.height - 580;
vue.prototype.$windowHeight = window.screen.height;
// vue.prototype.$domain='http://localhost:54514/'
vue.prototype.$paths = '/mp' //13423
vue.prototype.$domain = 'http://apps.shibakefu.com/'
vue.prototype.$imageLimit = 0;
vue.prototype.$pageParams = (form, i) => {
	var data = {params: form};
	data.params.pageSize = store.state.list.pageSize || 10;
	data.params.pageOrder = store.state.list.pageOrder || '';
	data.params.pageSort = store.state.list.pageSort || '';
	data.params.pageIndex = store.state.list.pageIndex || 0;
	if (i)
		data.params.pageIndex = i - 1;
	data.params.stime = "";
	data.params.etime = "";
	if (form.dateRange && form.dateRange.length == 2) {
		data.params.stime = vue.prototype.$getTime("yyyymmddhhmfss", form.dateRange[0]);
		data.params.etime = vue.prototype.$getTime("yyyymmddhhmfss", form.dateRange[1]);
	}
	return data;
}

vue.prototype.$allSpace = (text) => {
	return text.replace(/\s+/g, "");
}

vue.prototype.$copyText = (text) => {
	 var tag = document.createElement('input');
	    tag.setAttribute('id', 'copy_input');
	    tag.value = text;
	    document.getElementsByTagName('body')[0].appendChild(tag);
	    document.getElementById('copy_input').select();
	    document.execCommand('copy');
	    document.getElementById('copy_input').remove();
		element.Message.success('复制内容成功')
}
vue.prototype.$guid = () => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0,
			v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

vue.prototype.$getTime = (format, newdate) => {
	var date = newdate ? newdate : new Date();
	if (typeof(date) == 'string') return date;
	let yy = date.getFullYear();
	let mm = date.getMonth() + 1;
	let dd = date.getDate();
	let hh = date.getHours();
	let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	if (!format) {
		return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
	}
	var str = "";
	str += format.indexOf("yyyy") != -1 ? yy : '';
	str += format.indexOf("mm") != -1 ? '-' + mm : '';
	str += format.indexOf("dd") != -1 ? '-' + dd : '';
	str += format.indexOf("hh") != -1 ? ' ' + hh : '';
	str += format.indexOf("mf") != -1 ? ':' + mf : '';
	str += format.indexOf("ss") != -1 ? ':' + ss : '';
	return str;
}
vue.prototype.$dateRangeCurrent = [];
// vue.prototype.$dateRangeCurrentnew = [new Date(vue.prototype.$getTime("yyyymmdd") + " 00:00:00"), new Date(vue.prototype
// 	.$getTime("yyyymmdd") + " 23:59:59")];
vue.prototype.$setTimeout = (i) => {
	return new Promise((resolve, reject) => {
		setTimeout(e => {
			resolve()
		}, i)
	})
}

//通过Vue的指令方法，定义指令名称
vue.directive('int', {
  // bind绑定 获取当前目标的input（就是在哪个文本框上使用指令）
  bind: function(el) {
    const input = el.getElementsByTagName('input')[0];
    if (input) {
      // 调用input方法，加入正则校验的逻辑
      input.onkeyup = function(e) {
		   input.value= input.value.length>9? input.value.substring(0,9):  input.value;
        if (input.value.length === 1) {
          input.value = input.value.replace(/[^0-9]/g, '');
        } else {
          input.value = input.value.replace(/[^\d]/g, '');
        }
        // 调用自定义事件
        trigger(input, 'input');
      };
      input.onblur = function(e) {
		     input.value= input.value.length>9? input.value.substring(0,9):  input.value;
        if (input.value.length === 1) {
          input.value = input.value.replace(/[^0-9]/g, '');
        } else {
          input.value = input.value.replace(/[^\d]/g, '');
        }
        trigger(input, 'input');
      };
    }
  }
});


vue.directive('double', {
  // bind绑定 获取当前目标的input（就是在哪个文本框上使用指令）
  bind: function(el) {
    const input = el.getElementsByTagName('input')[0];
    if (input) {
      // 调用input方法，加入正则校验的逻辑
      input.onkeyup = function(e) {
        // if (input.value.length === 1) {
        //   input.value = input.value.replace(/[^0-9]/g, '');
        // } else {
        //   input.value = input.value.replace(/[^\d]/g, '');
        // }
		let value = input.value.toString();
		value = value.replace(/。/g, ".");
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字
		value = value.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
		input.value=value;
        // 调用自定义事件
        trigger(input, 'input');
      };
      input.onblur = function(e) {
        // if (input.value.length === 1) {
        //   input.value = input.value.replace(/[^0-9]/g, '');
        // } else {
        //   input.value = input.value.replace(/[^\d]/g, '');
        // }
		  let value = input.value.toString();
		  //value = value.replace(/。/g, ".");
		  value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		  value = value.replace(/^\./g, ""); //验证第一个字符是数字
		  value = value.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
		  value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
		  input.value=value;
        trigger(input, 'input');
      };
    }
  }
});
// 创建自定义事件
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  // 初始化默认值
  e.initEvent(type, true, true);
  // 触发自定义事件
  el.dispatchEvent(e);
};
new vue({
	router,
	store,
	i18n,
	render: h => h(app)
}).$mount('#app');
